import React, { useContext } from 'react';

import { ApiContext } from 'Services/api-context';
import { ServiceProviderProps } from './common';
import { AccountingServiceContext, IAccountingService } from 'Services/accounting';

export const AccountingServiceProvider: React.FC<ServiceProviderProps<IAccountingService>> = ( props, context ) => {

  const api = useContext( ApiContext );
  const accountingService: IAccountingService = new props.useClass( api );

  return (
    <AccountingServiceContext.Provider value={ accountingService }>
      { props.children }
    </AccountingServiceContext.Provider>
  );
};

